import { TableColumnRelation } from "../../ui/context/TableContext";

export type AttendanceSupTableColumns = {
  entry: string;
  departure: string;
  name: string;
  unity: string;
  observation: string;
  actions: string;
};

export const AttendanceSupTableSchema: TableColumnRelation<AttendanceSupTableColumns> =
  {
    large: {
      breakpoints: ["lg", "xl", "2xl"],
      columns: [
        {
          name: "entry",
          label: "Ingreso",
          weight: 0.1,
        },
        {
          name: "departure",
          label: "Salida",
          weight: 0.1,
        },
        {
          name: "name",
          label: "Operador",
          weight: 0.4,
        },
        {
          name: "unity",
          label: "Unidad",
          weight: 0.3,
        },
        {
          name: "observation",
          label: "Observación",
          weight: 0.1,
        },
        {
          name: "actions",
          label: "Acciones",
          weight: 0.1,
        },
      ],
    },
  };
